import { getJobFunctionLabel, getJobFieldValue } from 'pages/MergeProfiles/utils'

export const findJobsBySearchTerm = (jobs, searchTerm) => {
  if (!searchTerm.trim()) {
    return jobs
  }
  const lowerSearch = searchTerm.toLowerCase()
  return jobs.filter(job => {
    const title = getJobFunctionLabel(job)?.toLowerCase() || ''
    const orgName = job.organization?.name?.toLowerCase() || ''
    return title.includes(lowerSearch) || orgName.includes(lowerSearch)
  })
}

/**
 * Reconstructs UI state for override selections when editing job mappings
 *
 * @param {string[]} sourceJobIds - Array of source job IDs being edited
 * @param {Array} sourceJobs - Array of all source job objects
 * @param {Function} getMappingBySourceId - Function to get mapping data for a source job ID
 * @returns {Object} - UI state object mapping field keys to source job IDs
 *
 * @example
 * // Saved mappings have actual values:
 * // { sourceJob1: { overrideValues: { email: 'john@example.com' } } }
 * // This function returns UI state:
 * // { email: 'sourceJob1' } (which source job to select in radio)
 */
export const getMergedOverridesForEdit = (sourceJobIds, sourceJobs, getMappingBySourceId) => {
  const mergedOverrides = {}

  sourceJobIds.forEach(sourceId => {
    const mapping = getMappingBySourceId(sourceId)
    if (mapping?.overrideValues) {
      Object.entries(mapping.overrideValues).forEach(([fieldKey, overrideValue]) => {
        // Find the source job
        const sourceJob = sourceJobs.find(job => job.id === sourceId)
        if (!sourceJob) {
          return
        }

        // Get the actual value from this source job
        const jobValue = getJobFieldValue(sourceJob, fieldKey, { defaultValue: null })

        // Normalize for comparison (handle null, trim whitespace)
        const normalizedJobValue = jobValue?.toString().trim() || null
        const normalizedOverrideValue = overrideValue?.toString().trim() || null

        // If they match, this source job is the one that was selected for this field
        if (normalizedJobValue === normalizedOverrideValue) {
          mergedOverrides[fieldKey] = sourceId
        }
        // If no match found, radio will default to 'factset'
      })
    }
  })

  return mergedOverrides
}
